export default "__VITE_ASSET__20da08e3__"